import { useEffect, useState } from "react";
import { useT } from "../i18n";
import axios from "axios";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Header from "./Header";

function Mlogin(props) {
    const t = useT();
    const [formState, setFormState] = useState('login');
    const [formFrontIndex, setFormFrontIndex] = useState(0);
    const [loginWarningTxt, setLoginWarningTxt] = useState('');
    const [returnUrl, setReturnUrl] = useState('');
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        props.checkLogin();
        const url = window.location.href;
        if (location.state === null) {
            setReturnUrl(url.substring(0, url.lastIndexOf('/')));
        } else {
            setReturnUrl(location.state.returnUrl);
        }
    }, []);

    function login() {
        const form = document.loginForm;
        if (!form.id.value || !form.pw.value) {
            setLoginWarningTxt(t('아이디 와 비밀번호를 모두 입력해주세요.'));
            if (!form.id.value) {
                form.id.focus();
            } else {
                form.pw.focus();
            }
            return false;
        }
        axios({
            method: 'post',
            url: process.env.REACT_APP_LOGIN_SERVER_URL,
            data: {
                id: form.id.value,
                pw: form.pw.value,
            },
            withCredentials: true
        }).then((response) => {
            setLoginWarningTxt('');
            navigate(-1);
            // sessionStorage.setItem('user', JSON.stringify(response.data));//user 정보를 sessionStorage 에 저장해놓는건데 이렇게하면안될듯
        }).catch((error) => {
            console.log(error.response.data);
            setLoginWarningTxt(error.response.data);
        });

    }


    return (
        <>
            <Header userInfo={null} logout={props.logout} />
            <div id="MloginPage">
                <main>
                    <div className="m_login_bnr">
                        <h2>{t('환영합니다!')}</h2>
                        <p>{t('집을 짓기 위한 새로운 여정,')}<br />{t('프롭메이트와 함께 하세요!')}</p>
                    </div>
                    <ul className="tab_list">
                        <li>
                            <button type="button" className="login_tab" onClick={() => { setFormState('login') }}>{t('로그인')}</button>
                        </li>
                        <li>
                            <button type="button" className="join_tab" onClick={() => { setFormState('join') }}>{t('회원가입')}</button>
                        </li>
                    </ul>
                    <ul className="form_container">
                        <li className={formState === 'login' ? 'display_y' : ''}>
                            <form id="login_container" name="loginForm">
                                <fieldset>
                                    <legend>{t('로그인박스')}</legend>
                                    <ul className="login_wrap">
                                        <li className="login_box id_box">
                                            <div className="txt_box login_id">
                                                <span>ID</span>
                                                <a onClick={() => { setFormState('findId') }}>{t('아이디 찾기')}</a>
                                            </div>
                                            <p className="input_box_shadow"><input className="login_id_empty" type="text" placeholder={t("프롭메이트 아이디 입력")} name="id" onKeyDown={(e) => { if (e.keyCode === 13) { login() } }} /></p>
                                        </li>
                                        <li className="login_box pw_box">
                                            <div className="txt_box login_pw">
                                                <span>Password</span>
                                                <a onClick={() => { setFormState('findPw') }}>{t('비밀번호 재설정')}</a>
                                            </div>
                                            <p className="input_box_shadow"><input className="login_pw_empty" type="password" placeholder={t("프롭메이트 비밀번호 입력")} name="pw" onKeyDown={(e) => { if (e.keyCode === 13) { login() } }} /></p>
                                        </li>
                                        <li>
                                            <span className="login_warning_txt">{loginWarningTxt}</span>
                                        </li>
                                        <li>
                                            <ul className="login_btn_box">
                                                <li className="kakao_btn" id="kakao-login-btn">
                                                    <a href={`${process.env.REACT_APP_KAKAO_SERVER_URL}?returnUrl=${returnUrl}`}><img src="images/kakao_login.png" alt={t("카카오로그인버튼")} title={t("카카오로그인")} /></a>
                                                </li>
                                                <li className="naver_btn">
                                                    <a className="naver_real_btn" href={`${process.env.REACT_APP_NAVER_SERVER_URL}?returnUrl=${returnUrl}`}><img src="images/naver_login.png" alt={t("네이버로그인버튼")} title={t("네이버로그인")} /></a>

                                                </li>
                                                <li className="login_btn" onClick={login}><a>{t('로그인')}</a></li>
                                            </ul>
                                        </li>
                                    </ul>
                                </fieldset>
                            </form>
                        </li>
                        <li className={formState === 'join' ? 'display_y' : ''}>
                            <JoinForm formFrontIndex={formFrontIndex} setFormState={setFormState} navigate={navigate} />
                        </li>
                        <li className={formState === 'findId' ? 'display_y' : ''}>
                            <FindIdForm formFrontIndex={formFrontIndex} setFormState={setFormState} />
                        </li>
                        <li className={formState === 'findPw' ? 'display_y' : ''}>
                            <FindPwForm formFrontIndex={formFrontIndex} setFormState={setFormState} />
                        </li>
                    </ul>
                </main>
                {/* <div className="footer_bg">
                        <footer>
                            <ul className="footer_info">
                                <li><address>주소 | 서울시 관악구 문성로 199-1 2층</address></li>
                                <li>대표 | 고호준</li>
                                <li>개인정보 관리 책임자 | 이형우</li>
                                <li>사업자등록번호 | 469-81-03262</li>
                            </ul>
                            <ul className="footer_link">
                                <li><Link to={'/Company'}>회사소개</Link></li>
                                <li><Link to={'/agree'} state={{ index : 0}}>이용약관</Link></li>
                                <li><Link to={'/agree'} state={{ index : 1}}>개인정보처리방침</Link></li>
                                <li><Link to={'/agree'} state={{ index : 2}}>위치기반 서비스 이용약관</Link></li>
                            </ul>
                            <p>Copyright 2023 propmate Inc. all rights reserved.</p>
                        </footer>
                    </div> */}
            </div>
        </>
    )
}




function JoinForm(props) {
    const t = useT();
    const [joinWarningTxt, setJoinWarningTxt] = useState('');
    const [idWarningTxt, setIdWarningTxt] = useState('');
    const [pwWarningTxt, setPwWarningTxt] = useState('');
    const [phWarningTxt, setPhWarningTxt] = useState('');
    const [nameWarningTxt, setNameWarningTxt] = useState('');
    const [emailWarningTxt, setEmailWarningTxt] = useState('');
    const [joinBtnState, setJoinBtnState] = useState('disabled');
    const idRegExp = /^[a-zA-z0-9]{4,12}$/;
    const pwRegExp = /^[a-zA-z0-9]{8,20}$/;
    const phRegExp = /^\d{11,12}$/;
    const emailRegExp = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    function checkValue(RegExp, value, setUseState, message) {
        if (!RegExp.test(value)) {
            setUseState(message);
        } else {
            setUseState('');
        }
    }
    function onChangeAgreeAll() {
        const form = document.joinForm;
        console.log(form.agree_play.checked, form.agree_secret.checked, form.agree_gps.checked, form.agree_promotion.checked);
        if (!form.agree_play.checked || !form.agree_secret.checked || !form.agree_gps.checked || !form.agree_promotion.checked) {
            form.agree_play.checked = true;
            form.agree_secret.checked = true;
            form.agree_gps.checked = true;
            form.agree_promotion.checked = true;
            form.agree_all.checked = true;
        } else {
            form.agree_play.checked = false;
            form.agree_secret.checked = false;
            form.agree_gps.checked = false;
            form.agree_promotion.checked = false;
            form.agree_all.checked = false;
        }

        if (form.agree_play.checked && form.agree_secret.checked) {
            setJoinBtnState('');
        } else {
            setJoinBtnState('disabled');
        }
    }

    function onChangeAgree() {
        const form = document.joinForm;
        if (!form.agree_play.checked || !form.agree_secret.checked || !form.agree_gps.checked || !form.agree_promotion.checked) {
            form.agree_all.checked = false;
        } else if (form.agree_play.checked && form.agree_secret.checked && form.agree_gps.checked && form.agree_promotion.checked) {
            form.agree_all.checked = true;
        }
        if (form.agree_play.checked && form.agree_secret.checked) {
            setJoinBtnState('');
        } else {
            setJoinBtnState('disabled');
        }
    }

    function join() {
        setJoinWarningTxt('');
        const form = document.joinForm;
        let year = form.birthYear.value.toString().padStart(4, '0');
        let month = form.birthMonth.value.toString().padStart(2, '0');
        let day = form.birthDay.value.toString().padStart(2, '0');
        const birth = `${year}-${month}-${day}`
        if (!form._id.value || !form.pw.value || !form.ph.value || !form.name.value || !form.email.value) {
            if (!form.email.value) {
                form.email.focus()
                setEmailWarningTxt(t('이메일을 입력해주세요.'));
            }
            if (!form.name.value) {
                form.name.focus()
                setNameWarningTxt(t('이름(기업명)을 입력해주세요.'));
            }
            if (!form.ph.value) {
                form.ph.focus()
                setPhWarningTxt(t('전화번호를 입력해주세요.'));
            }
            if (!form.pw.value) {
                form.pw.focus()
                setPwWarningTxt(t('비밀번호를 입력해주세요.'));
            }
            if (!form._id.value) {
                form._id.focus()
                setIdWarningTxt(t('아이디를 입력해주세요.'));
            }
            return false;
        }
        if (joinWarningTxt !== '' || idWarningTxt !== '' || pwWarningTxt !== '' || phWarningTxt !== '' || nameWarningTxt !== '' || emailWarningTxt !== '') {
            if (emailWarningTxt !== '') {
                form.email.focus()
            }
            if (nameWarningTxt !== '') {
                form.name.focus()
            }
            if (phWarningTxt !== '') {
                form.ph.focus()
            }
            if (pwWarningTxt !== '') {
                form.pw.focus()
            }
            if (idWarningTxt !== '') {
                form._id.focus()
            }
            return false;
        }
        axios({
            method: 'post',
            url: process.env.REACT_APP_JOIN_SERVER_URL,
            data: {
                _id: form._id.value,
                pw: form.pw.value,
                ph: form.ph.value,
                name: form.name.value,
                email: form.email.value,
                gender: form.gender.value,
                birth: birth,
                occu: form.occu.value,
                agree: {
                    agree_play: form.agree_play.checked,
                    agree_secret: form.agree_secret.checked,
                    agree_gps: form.agree_gps.checked,
                    agree_promotion: form.agree_promotion.checked,
                },
                userLevel: 'user',
            }
        }).then((response) => {
            console.log(response.data);
            alert(t('회원가입이 완료되었습니다.'));
            props.setFormState('login');

        }).catch((error) => {
            setJoinWarningTxt(error.response.data);
        });

    }


    return (
        <form id="join_wrap" action="#" method="get" className={props.formFrontIndex == 0 ? "front" : ''} name="joinForm">
            <fieldset>
                <legend>{t('회원가입박스')}</legend>
                <ul className="join_box">
                    <li>
                        <div className="txt_box_con">
                            <p className="txt_box">ID</p><span className="warning_txt">{idWarningTxt}</span>
                        </div>
                        <p className="input_box_shadow"><input className="join_id_empty" type="text" placeholder={t("아이디 입력")} name="_id" onChange={(e) => { checkValue(idRegExp, e.target.value, setIdWarningTxt, t('영문 대소문자와 숫자 4~12자리')); }} /></p>
                    </li>
                    <li>
                        <div className="txt_box_con">
                            <p className="txt_box">Password</p><span className="warning_txt">{pwWarningTxt}</span>
                        </div>
                        <p className="input_box_shadow"><input className="join_pw_empty" type="password" placeholder={t("비밀번호 입력")} name="pw" onChange={(e) => { checkValue(pwRegExp, e.target.value, setPwWarningTxt, t('영문 대소문자와 숫자 8~20자리')); if (pwRegExp.test(e.target.value) && document.joinForm.pwck.value !== e.target.value) { setPwWarningTxt(t('비밀번호 확인란을 입력해주세요.')) } }} /></p>
                        <p className="input_box_shadow"><input className="join_pwck_empty" type="password" placeholder={t("비밀번호 확인")} name="pwck" onChange={(e) => { if (document.joinForm.pw.value !== e.target.value) { setPwWarningTxt(t('비밀번호가 일치하지 않습니다.')) } else if (document.joinForm.pw.value == e.target.value) { setPwWarningTxt('') } }} /></p>
                    </li>
                    <li>
                        <div className="txt_box_con">
                            <p className="txt_box">PhoneNumber</p><span className="warning_txt">{phWarningTxt}</span>
                        </div>
                        <p className="input_box_shadow"><input className="join_phone_empty" type="number" placeholder={t("전화번호 입력 (숫자만)")} name="ph" onChange={(e) => { checkValue(phRegExp, e.target.value, setPhWarningTxt, t('전화번호를 입력해주세요.')); }} /></p>
                    </li>
                    <li>
                        <div className="txt_box_con">
                            <p className="txt_box">Name/Company</p><span className="warning_txt">{nameWarningTxt}</span>
                        </div>
                        <p className="input_box_shadow"><input className="join_name_empty" type="text" placeholder={t("이름(기업명) 입력")} name="name" onChange={(e) => { if (e.target.value) { setNameWarningTxt('') } }} /></p>
                    </li>
                    <li>

                        <div className="txt_box_con">
                            <p className="txt_box">Email</p><span className="warning_txt">{emailWarningTxt}</span>
                        </div>
                        <p className="input_box_shadow"><input className="join_mail_empty" type="text" placeholder={t("이메일 입력")} name="email" onChange={(e) => { checkValue(emailRegExp, e.target.value, setEmailWarningTxt, t('이메일 형식으로 입력해주세요.')); }} /></p>
                    </li>
                    <li className="select_form">
                        <p>Gender<span>{t('선택')}</span></p>
                        <div className="join_select">
                            <input type="radio" id="select1" name="gender" value="male" />
                            <label htmlFor="select1">{t('남자')}</label>
                            <input type="radio" id="select2" name="gender" value="female" />
                            <label htmlFor="select2">{t('여자')}</label>
                        </div>
                    </li>
                    <li className="select_form">
                        <p>Birthday<span>{t('선택')}</span></p>
                        <div className="join_select birth">
                            <p className="input_box_shadow"><input type="number" placeholder={t("년(4자)")} name="birthYear" /></p>
                            <select name="birthMonth">
                                <option value="null" className="month">{t('--월')}</option>
                                <option value="1">{t('1월')}</option>
                                <option value="2">{t('2월')}</option>
                                <option value="3">{t('3월')}</option>
                                <option value="4">{t('4월')}</option>
                                <option value="5">{t('5월')}</option>
                                <option value="6">{t('6월')}</option>
                                <option value="7">{t('7월')}</option>
                                <option value="8">{t('8월')}</option>
                                <option value="9">{t('9월')}</option>
                                <option value="10">{t('10월')}</option>
                                <option value="11">{t('11월')}</option>
                                <option value="12">{t('12월')}</option>
                            </select>
                            <p className="input_box_shadow"><input type="number" placeholder={t("일")} name="birthDay" /></p>
                        </div>
                    </li>
                    <li className="select_form">
                        <p>Occupational<span>{t('선택')}</span></p>
                        <div className="join_occu_select">
                            <select name="occu">
                                <option value="null">{t('직업 선택')}</option>
                                <option value="prospectiveBuilder">{t('예비 건축주')}</option>
                                <option value="constructionWorker">{t('건축업 종사자')}</option>
                            </select>
                        </div>
                    </li>
                </ul>
                <div className="agree_wrap">
                    <p>
                        <input type="checkbox" name="agree_all" id="agree_all" onChange={onChangeAgreeAll} />
                        <label htmlFor="agree_all">{t('프롭메이트 정보수집에 모두 동의합니다.')}</label>
                    </p>
                    <ul className="agree_select">
                        <li>
                            <div className="clause">
                                <input type="checkbox" id="play" name="agree_play" onChange={onChangeAgree} />
                                <label htmlFor="play">{t('프롭메이트 이용약관 동의')}<span>{t('필수')}</span></label>
                            </div>
                            <p><Link to='/agree' state={{ index: 0 }}>{t('자세히보기')}</Link></p>
                        </li>
                        <li>
                            <div className="clause">
                                <input type="checkbox" id="secret" name="agree_secret" onChange={onChangeAgree} />
                                <label htmlFor="secret">{t('개인정보 수집 및 이용 동의')}<span>{t('필수')}</span></label>
                            </div>
                            <p><Link to='/agree' state={{ index: 1 }}>{t('자세히보기')}</Link></p>
                        </li>
                        <li>
                            <div className="clause">
                                <input type="checkbox" id="gps" name="agree_gps" onChange={onChangeAgree} />
                                <label htmlFor="gps">{t('위치기반서비스 이용약관 동의')}<span>{t('선택')}</span></label>
                            </div>
                            <p><Link to='/agree' state={{ index: 2 }}>{t('자세히보기')}</Link></p>
                        </li>
                        <li>
                            <div className="clause">
                                <input type="checkbox" id="promotion" name="agree_promotion" onChange={onChangeAgree} />
                                <label htmlFor="promotion">{t('프로모션 정보 수신 동의')}<span>{t('선택')}</span></label>
                            </div>
                            <p><Link to='/agree' state={{ index: 3 }}>{t('자세히보기')}</Link></p>
                        </li>
                        <li>
                            <span className="join_warning_txt">{joinWarningTxt}</span>
                        </li>
                    </ul>
                </div>
                <p className={`join_submit ${joinBtnState}`}><a className="join_submit_btn" onClick={join}>{t('회원가입')}</a></p>
            </fieldset>
        </form>
    )
}

function FindIdForm(props) {
    const t = useT();
    const find_id_form = document.find_id;
    function id_find() {
        axios({
            method: 'post',
            url: process.env.REACT_APP_IDFINDER_SERVER_URL,
            data: {
                email: find_id_form.email.value
            }
        }).then((response) => {
            alert(`아이디 : ${response.data}`);
            props.setFormState('logi ');
        }).catch((error) => {
            alert(error.response.data);
        });
    }
    return (
        <form id="find_id" name="find_id" action="#" method="get" className={props.formFrontIndex == 1 ? "front" : ''}>
            <fieldset>
                <legend>{t('아이디찾기')}</legend>
                <h3>{t('아이디 찾기')}</h3>
                <ul className="find_box">
                    <li>
                        <p className="find_email txt_box">EMAIL</p>
                        <p className="input_box_shadow"><input className="find_pw_empty" type="text" placeholder={t("가입한 이메일 입력")} name="email" /></p>
                    </li>
                </ul>
                <p><span className="find_id_warning_txt"></span></p>
                <p className="find_id"><a href="#" className="find_id_btn" onClick={id_find}>{t('아이디 찾기')}</a></p>
            </fieldset>
        </form>
    )
}

function FindPwForm(props) {
    const t = useT();
    const [findPwBtnState, setFindPwBtnState] = useState(false);
    const [authNumber, setAuthNumber] = useState(null);
    const pwRegExp = /^[a-zA-z0-9]{8,20}$/;
    const [pwWarningTxt, setPwWarningTxt] = useState('');
    const find_pw_form = document.find_pw;
    function email_auth(e) {
        e.preventDefault();
        axios({
            method: 'post',
            url: process.env.REACT_APP_EMAILAUTH_SERVER_URL,
            data: {
                id: find_pw_form.id.value,
                email: find_pw_form.email.value
            }
        }).then((response) => {
            alert(t('이메일에 인증번호를 보냈습니다.'));
            setAuthNumber(response.data);
        }).catch((error) => {
            alert(error.response.data);
            setAuthNumber(null);
        });
    }
    function auth_number_check(e) {
        e.preventDefault();
        if (Number(authNumber) === Number(find_pw_form.authNumber.value)) {
            alert(t('인증완료.'));
            setFindPwBtnState(true);
        } else {
            alert(t('인증에 실패했습니다. 다시 인증요청 해주시길 바랍니다.'));
            setAuthNumber(null);
            setFindPwBtnState(false);

        }
    }
    function checkValue(RegExp, value, setUseState, message) {
        if (!RegExp.test(value)) {
            setUseState(message);
        } else {
            setUseState('');
        }
    }


    function resetPassword(e) {
        e.preventDefault();
        if (findPwBtnState === false) { return false }
        axios({
            method: 'post',
            url: process.env.REACT_APP_RESETPASSWORD_SERVER_URL,
            data: {
                id: find_pw_form.id.value,
                newPw: find_pw_form.pw.value
            }
        }).then((response) => {
            alert(t('비밀번호 변경완료'));
            props.setFormState('login');

        }).catch((error) => {
            alert(error.response.data);
            setAuthNumber(null);
            setFindPwBtnState(false);
        });
    }

    return (
        <form id="find_pw" name="find_pw" action="#" method="get" className={props.formFrontIndex == 2 ? "front" : ''}>
            <fieldset>
                <legend>{t('비밀번호 재설정')}</legend>
                <h3>{t('비밀번호 재설정')}</h3>
                <ul className="find_box">
                    <li>
                        <p className="find_email txt_box">ID</p>
                        <p className="input_box_shadow"><input className="find_pw_empty" name="id" type="text" placeholder={t("가입한 아이디 입력")} />
                        </p>
                    </li>
                    <li>
                        <p className="find_email txt_box">Email</p>
                        <p className="input_box_shadow"><input className="find_pw_empty" name="email" type="text" placeholder={t("가입한 이메일 입력")} />
                            <button type="submit" className="confirm_email" onClick={email_auth}>{t('인증요청')}</button>
                        </p>
                    </li>
                    <li>
                        <p className="find_email txt_box">{t('인증번호')}</p>
                        <p className="input_box_shadow"><input className="find_pw_empty" name="authNumber" type="text" placeholder={t("인증번호 입력")} />
                            <button type="submit" className={`confirm_email ${authNumber === null ? "disabled" : ""}`} onClick={auth_number_check}>{t('인증확인')}</button>
                        </p>
                    </li>
                    <li>
                        <p className="txt_box">Password</p><span className="warning_txt">{pwWarningTxt}</span>
                        <p className="input_box_shadow"><input className="join_pw_empty" type="password" placeholder={t("비밀번호 입력")} name="pw" onChange={(e) => { checkValue(pwRegExp, e.target.value, setPwWarningTxt, t('영문 대소문자와 숫자 8~20자리')); if (pwRegExp.test(e.target.value) && document.find_pw.pwck.value !== e.target.value) { setPwWarningTxt(t('비밀번호 확인란을 입력해주세요.')) } }} /></p>
                        <p className="input_box_shadow"><input className="join_pwck_empty" type="password" placeholder={t("비밀번호 확인")} name="pwck" onChange={(e) => { if (document.find_pw.pw.value !== e.target.value) { setPwWarningTxt(t('비밀번호가 일치하지 않습니다.')) } else if (document.find_pw.pw.value == e.target.value) { setPwWarningTxt('') } }} /></p>
                    </li>
                </ul>
                <p><span className="find_pw_warning_txt"></span></p>
                <p className="find_pw"><a href="#" className={`find_pw_btn ${findPwBtnState === true && pwWarningTxt === '' ? "" : "disabled"}`} onClick={resetPassword}>{t('비밀번호 재설정')}</a></p>
            </fieldset>
        </form>
    )
}
export default Mlogin;